import React from "react";
import Chart from "react-apexcharts";
import { Card, CardBody } from "reactstrap";

const cardShell = {
  background: "var(--vz-secondary-bg, #fff)",
  border: "1px solid var(--vz-border-color)",
  borderRadius: 10,
  boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
  overflow: "hidden",
};

const PlaybookGraph = () => {
  const series = [
    {
      name: "Playbooks Triggered",
      data: [180, 120, 90, 60, 30],
    },
  ];

  const options = {
    chart: {
      type: "bar",
      toolbar: { show: false },
      background: "transparent",
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "55%",
        borderRadius: 4,
      },
    },
    dataLabels: { enabled: false },
    colors: ["#FF5B00"],
    grid: { borderColor: "#e9ecef", strokeDashArray: 3 },
    xaxis: {
      categories: ["Phishing", "Malware", "DDoS", "EDR", "Vulnerability"],
      labels: {
        style: { colors: "#4B5563", fontSize: "12px" },
      },
      axisBorder: { show: false },
      axisTicks: { show: false },
    },
    yaxis: {
      labels: {
        style: { colors: "#4B5563", fontSize: "11px" },
      },
      min: 0,
      max: 180,
      tickAmount: 4,
    },
    legend: {
      show: true,
      position: "bottom",
      horizontalAlign: "center",
      labels: { colors: "#374151" },
      markers: { width: 10, height: 10, radius: 2 },
    },
    tooltip: {
      theme: "auto",
      y: { formatter: val => `${val} playbooks` },
    },
  };

  return (
    <Card
      className="border-0 shadow-sm mt-4"
      style={cardShell}
    >
      <CardBody>
        <h5 className="fw-bold mb-3" style={{ color: "var(--bs-body-color)", backgroundColor:"var(--bs-secondary-bg)" }}>
          Playbooks triggered per alert type
        </h5>
        <div style={{ width: "100%", height: "300px" }}>
          <Chart options={options} series={series} type="bar" height="300" />
        </div>
      </CardBody>
    </Card>
  );
};

export default PlaybookGraph;
